import { render } from "./App.vue?vue&type=template&id=220f5a1e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=220f5a1e&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__